const testimonials = [
  {
    name: "David L.",
    location: "Telecom Corridor, Richardson TX",
    rating: 5,
    text: "I'm a senior engineer at a telecom company on Campbell Road. Got called into a critical site visit in Stockholm with 11 days notice. My passport had exactly 4 months left — rejected by the airline booking system. Fast Passport Center turned around my renewal in 7 business days. I made my flight and closed the deal. Genuinely don't know what I would have done otherwise.",
    service: "Passport Renewal",
  },
  {
    name: "The Patel Family",
    location: "Canyon Creek, Richardson TX",
    rating: 5,
    text: "Our daughter got into a UTD study abroad program in Barcelona and we discovered she'd never had a passport. Fast Passport Center walked us through the first-time application process, told us exactly which post office to visit, and expedited the passport after the clerk visit. She made it to orientation on time. Worth every penny.",
    service: "New Passport — UTD Study Abroad",
  },
  {
    name: "Jennifer &amp; Mark S.",
    location: "Spring Valley, Richardson TX",
    rating: 5,
    text: "Booked a last-minute family trip to Cancun and discovered our son's passport had expired. Panicked completely. Called Fast Passport Center on Wednesday, shipped documents Thursday, had the passport in hand by the following Wednesday. We flew out that Friday. The team communicated every step of the way. Incredible service.",
    service: "Emergency Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return <div className="flex items-center gap-0.5">{Array.from({ length: count }).map((_, i) => <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>)}</div>;
}

export default function RichardsonTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Richardson Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Telecom Corridor professionals, UTD students, and Richardson families who trusted Fast Passport Center.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic" dangerouslySetInnerHTML={{ __html: `&ldquo;${t.text}&rdquo;` }} />
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm" dangerouslySetInnerHTML={{ __html: t.name }} />
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">{t.service}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}